import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Check, BookOpen } from 'lucide-react';
import { heroContent, tribalIdentityCard } from '../mock/data';

const Hero = () => {
  return (
    <section className="bg-gradient-to-br from-amber-50 to-green-50 py-12 lg:py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 items-center">
          {/* Main Hero Content */}
          <div className="lg:col-span-2">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              {heroContent.title.split('Ancestral Power')[0]}
              <span className="text-amber-600">Ancestral Power</span>
            </h1>
            <p className="mt-6 text-xl text-gray-600 leading-relaxed">
              {heroContent.subtitle}
            </p>
            
            {/* CTA Buttons */}
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="bg-green-700 hover:bg-green-800 text-white px-8 py-3 text-lg transition-all hover:scale-105"
                onClick={() => {
                  const pricingSection = document.querySelector('[data-section="pricing"]');
                  if (pricingSection) {
                    pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  }
                }}
              >
                {heroContent.buttons.primary}
              </Button>
            </div>
          </div>

          {/* Tribal Identity Card */}
          <div className="lg:col-span-1">
            <Card className="bg-white shadow-lg border-0 hover:shadow-xl transition-all duration-300">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-700 rounded-lg flex items-center justify-center mr-4">
                    <BookOpen className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900">
                      {tribalIdentityCard.title}
                    </h3>
                    <p className="text-gray-600">{tribalIdentityCard.subtitle}</p>
                  </div>
                </div>
                
                <ul className="space-y-3">
                  {tribalIdentityCard.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-gray-700">
                      <Check className="w-5 h-5 text-green-600 mr-3 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;